import { store } from '@/common/root';
import jsonParseSafe from '@/common/utils/jsonParseSafe';
import checkTopLevelStorageAccess from '@/common/utils/checkTopLevelStorageAccess';
import { UserAccount } from '@schema';
import type { useAuthStore } from '@/common/store/pinia/auth';
import type { usePermissionsStore } from '@/common/store/pinia/permissions';

async function initSelfService({
  authStore,
  permissionsStore
}: {
  authStore: ReturnType<typeof useAuthStore>,
  permissionsStore: ReturnType<typeof usePermissionsStore>
}) {
  await checkTopLevelStorageAccess(authStore.setStorageAccessState);

  /* Fetch and Set the current user in case there's one */
  const userCredentials = localStorage.getItem('user');
  const scopedToken = localStorage.getItem('scopedToken') || '';
  const domain = localStorage.getItem('domain') || '';
  const currentProject = localStorage.getItem('currentProject') || '';

  if (userCredentials) {
    authStore.setCurrentUser(jsonParseSafe(userCredentials) as UserAccount || {});
  }

  if (userCredentials || scopedToken) {
    authStore.setProject(currentProject);
    authStore.setToken(scopedToken);
    authStore.setDomain(domain);

    await authStore.checkAccessDisabled();
    if (authStore.accessDisabled) {
      return;
    }
    if (currentProject) {
      // check if the user still able to perform actions in the project
      await authStore.signInProject(currentProject);
    } else {
      await permissionsStore.fetchAuthMeta();
      await store.dispatch('socket/CONNECT');
    }
  }
}

export default initSelfService;
